/**
 * 🔴 L'ID DELLE RILETTURE CAUSATE DA UN EVENTO (contratto `fronti/qsocials/tempo-reale-e-dm.md` §1-bis).
 *
 * Le riletture che un evento del tempo reale fa partire portano `X-Request-Id: ev-<type>-<casuale>`:
 * QSocials lo adotta come `rid` dell'access log, ed e' la PROVA di R3 (la rilettura l'ha causata l'evento,
 * non il polling, non il focus, non un rimontaggio). Forma ammessa dal server: `^[A-Za-z0-9._:-]{1,64}$`
 * (un id fuori forma verrebbe sostituito e finirebbe solo in `rid-in`).
 *
 * RTK non ha un header per richiesta quando si invalida un tag. ⇒ Chi riceve l'evento SEGNA, per ogni
 * endpoint che ha davvero chi lo guarda, un id in attesa; `prepareHeaders` di `socialApi` lo PRENDE (e lo
 * consuma) alla prima richiesta di quell'endpoint entro `SCADENZA_MS`. Cosi' l'id arriva solo alla rilettura
 * dell'evento: non a un polling successivo (consumato), non a una lista montata dopo (non era segnata).
 * Questo file e' puro apposta: lo importa `socialApi`.
 */
export const FORMA_ID = /^[A-Za-z0-9._:-]{1,64}$/;
export const SCADENZA_MS = 10_000;

interface Attesa {
  id: string;
  restanti: number;
  scade: number;
}
const attese = new Map<string, Attesa>();

function casuale(): string {
  const b = new Uint8Array(9);
  crypto.getRandomValues(b);
  return Array.from(b, (x) => (x % 36).toString(36)).join('');
}

/** `ev-<type>-<casuale>`, sempre nella forma ammessa (caratteri estranei → `_`, al massimo 64). */
export function nuovoIdEvento(type: string): string {
  const t = type.replace(/[^A-Za-z0-9._:-]/g, '_').slice(0, 40) || 'x';
  return `ev-${t}-${casuale()}`.slice(0, 64);
}

/** Segna l'id per questi endpoint (uno per ogni rilettura attesa: lo stesso endpoint puo' contare 2). */
export function segnaRiletture(endpoint: readonly string[], id: string, ora = Date.now()): void {
  for (const e of endpoint) {
    const a = attese.get(e);
    if (a && a.id === id) a.restanti++;
    else attese.set(e, { id, restanti: 1, scade: ora + SCADENZA_MS });
  }
}

/** L'id in attesa per questo endpoint, CONSUMATO; `null` se non c'e' o e' scaduto. */
export function prendiIdEvento(endpoint: string, ora = Date.now()): string | null {
  const a = attese.get(endpoint);
  if (!a) return null;
  if (a.scade < ora) {
    attese.delete(endpoint);
    return null;
  }
  if (--a.restanti <= 0) attese.delete(endpoint);
  return a.id;
}

/** Solo per i test. */
export function dimenticaAttese(): void {
  attese.clear();
}
